import { Injectable } from '@angular/core';
import { GameStoreDispatcher } from '../core/state/game/game.dispatcher';
import { distinctUntilChanged, map, filter } from 'rxjs/operators';
import { firstValueFrom, Observable } from 'rxjs';
import { ComponentToLoad, GameStateId, GameToLoad } from '../core/state/game/game.state';

@Injectable({
    providedIn:'root',
})
export class SplitScreenService {

    selectedGame$: Observable<GameStateId>;
    gridView$: Observable<boolean>; //default true
    gameListLength$: Observable<number>;
    gamesList$: Observable<ComponentToLoad[]>;
    
    constructor (
        private gameDispatcher: GameStoreDispatcher
    ) {
        this.init();
    }

    init() {
        this.gridView$ = this.gameDispatcher.getState().pipe(
            map (gameState => {
                return gameState.gridView;
            }),
            distinctUntilChanged(),
        );

        this.selectedGame$ =  this.gameDispatcher.getState().pipe(
            distinctUntilChanged((x, y) => (x.selectedGame == y.selectedGame && x.gamesList.length == y.gamesList.length)),
            map (gameState => {
                const length = gameState.gamesList.length;
                for (let i: number = 0; i < length; i++) {
                    if (gameState.gamesList[i].gameStateId == gameState.selectedGame){
                        break;
                    }
                    this.selectGame(gameState.selectedGame); //We only have 1 game per tab, and selectedGame should be the game added by game dispatcher
                }
                return gameState.selectedGame;
            }),
        );

        this.gamesList$ = this.gameDispatcher.getState().pipe(
            map(gameState => gameState.gamesList),
            filter(games => games.length !== 0 ),
            distinctUntilChanged((x, y) => (x.length == y.length))
        );

        this.gameListLength$ = this.gameDispatcher.getState().pipe(
            map(gameState => gameState.gamesList.length),
            distinctUntilChanged()
        );

    }

    getGamesClubIdObs(gameStateId: string): Observable<string> {
        return this.gameDispatcher.getState().pipe(
            map(gameState => {
                const game = <GameToLoad>gameState.gamesList.find(game => game.gameStateId === gameStateId);
                if (game) return game.clubId;
            }),
            filter(clubid => clubid !== undefined),
            distinctUntilChanged()
        )
    }

    selectGame(selectedGameIndex: GameStateId) {
        this.gameDispatcher.setSelectedGame(selectedGameIndex);
    }

    setGridView(event: boolean) {
        this.gameDispatcher.setGridView(event);
    }

    async closeGame(gameStateId: GameStateId, invitationRejected?: boolean) {
        this.gameDispatcher.removeGame(gameStateId, undefined, invitationRejected);
    }

    async addGame(game: GameToLoad, toSelectGame: boolean, toNav = false) {
        const isInit = !toSelectGame;
        const addedGame = await this.gameDispatcher.addNewGame(game, toNav, isInit);
        if (!addedGame) return null;
        if (toSelectGame) await firstValueFrom(this.selectedGame$.pipe(filter((changedTo) => changedTo == addedGame.gameStateId)));
        return addedGame;
    }
}
